import axios from "axios";
import serialize from "json-form-data";
import { getApi } from "./utils";

export default {
    namespaced: true,

    state: {},

    mutations: {},

    getters: {},

    actions: {
        // types
        async getType(ctx, typeId) {
            const { url } = getApi(ctx);
            const { data } = await axios.get(url("api/inventory-type/view", { id: typeId }));
            return data;
        },

        async createType(ctx, params) {
            const { url } = getApi(ctx);
            const { files, ...typeParams } = params;
            const formData = serialize(typeParams);
            files.forEach((file) => {
                formData.append("files[]", file);
            });
            const { data } = await axios.post(url("api/inventory-type/create"), formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            return data;
        },

        async updateType(ctx, params) {
            const { url } = getApi(ctx);
            const { id, files, ...typeParams } = params;

            const formData = serialize(typeParams);

            files.forEach((file) => {
                formData.append("files[]", file);
            });

            const { data } = await axios.post(url("api/inventory-type/update", { id }), formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            return data;
        },

        async removeType(ctx, typeId) {
            const { url } = getApi(ctx);
            const { data } = await axios.get(url("api/inventory-items/delete-position", { position_id: typeId }));
            return data;
        },

        // categories
        async getCategories(ctx, params) {
            const { url } = getApi(ctx);

            const { data } = await axios.get(url("api/inventory-items/categories-list", { sub_cats: 1, ...params }));
            return data;
        },

        async createCategory(ctx, params) {
            const { url } = getApi(ctx);
            const { files, ...typeParams } = params;

            const formData = serialize(typeParams);

            files.forEach((file) => {
                formData.append("files[]", file);
            });

            const response = await axios.post(url("api/inventory-category/create"), formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            return response.data;
        },
        async updateCategory(ctx, params) {
            const { url } = getApi(ctx);
            const { id, files, responsible_id, ...typeParams } = params;

            const formData = serialize(typeParams);

            files.forEach((file) => {
                formData.append("files[]", file);
            });

            formData.append("responsible_id", responsible_id || "");

            const response = await axios.post(url("api/inventory-category/update", { id }), formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            return response.data;
        },

        async removeCategory(ctx, categoryId) {
            const { url } = getApi(ctx);
            const { data } = await axios.get(url("api/inventory-items/delete-category", { category_id: categoryId }));
            return data;
        },

        // archive

        async archiveOperation(ctx, params) {
            const { url } = getApi(ctx);
            const { typeId, action } = params;

            const { data } = await axios.get(
                url("api/inventory-items/archive-operations", { position_id: typeId, action }),
            );

            return data;
        },
    },
};
